<script>
    export default {
        name: "accordion-element",
        render(createElement)
        {
            return createElement(
                "div",
                {
                    staticClass: "accordion-content",
                    // class: this.$data.class
                },
                [this.$slots.default]
            );
        }
    }
</script>